import React, { useCallback, useState } from 'react';
import { useDropzone } from 'react-dropzone';
import styled from 'styled-components';
interface UploadMovieProps {
  onAcceptFile: Function,
  acceptFiles: string[],
  message?: string;
  maxSize?: number;
  maxFiles?: number;
}


const getColor = (props: any) => {
  if (props.isDragAccept) {
      return '#00e676';
  }
  if (props.isDragReject) {
      return '#ff1744';
  }
  if (props.isDragActive) {
      return '#2196f3';
  }
  return '#eeeeee';
}

const Container = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 20px;
  border-width: 2px;
  border-radius: 2px;
  border-color: ${props => getColor(props)};
  border-style: dashed;
  background-color: #fafafa;
  color: #bdbdbd;
  outline: none;
  transition: border .24s ease-in-out;
`;



const UploadMovie: React.FC<UploadMovieProps> = ({onAcceptFile, acceptFiles, message, maxSize, maxFiles}) =>  {
  const onDrop = useCallback(acceptFiles => {
    onAcceptFile(acceptFiles)
  }, []);

  const {getRootProps, getInputProps, isDragActive, isDragAccept, isDragReject} = useDropzone({accept: acceptFiles, maxSize , onDrop})


  return(
    <div className="container">
    <Container {...getRootProps({isDragActive, isDragAccept, isDragReject})}>
      <input {...getInputProps()} />
      {
        <p style={{color: 'red', fontSize: 16, fontWeight: 'bold'}}>{ message} </p>
      }
      <div>

      </div>
    </Container>
    </div>
  )
}

export default UploadMovie;
